// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"a9fb0286","428":"ee3a7b74"}[chunkId] + ".chunk.css";
};